import { AxiosResponse, AxiosError } from "axios";
import apiClient from './ApiConfig';

export interface NewsItem {
  id: number;
  headline: string;
  text: string;
  start_time: string;
  end_time: string;
  chapter: string;
  created_by_usr_id: number;
  created_time: string;
}

export function GetNews(
  callback: (statusCode: number, input: NewsItem[]) => void
) {
  apiClient({
    method: "get",
    url: "/currentnews",
  })
    .then(function (response: AxiosResponse) {
      callback(response.status, response.data.news_items as NewsItem[]);
    })
    .catch(function (error: AxiosError) {
      callback(error.response?.status || 0, {} as NewsItem[]);
    });
}
